import { NgModule } from "@angular/core";
import { SharedModule } from "@modules/shared";
import { ReportDataComponent } from "./components/report-data/report-data.component";
import { ReportNavComponent } from "./components/report-nav/report-nav.component";
import { ReportComponent } from "./components/report/report.component";
import { ReportRoutingModule } from "./report.routing.module";
import { ReportsService } from "./services/report-service/report.service";

@NgModule({
  imports: [SharedModule, ReportRoutingModule],
  declarations: [ReportDataComponent, ReportNavComponent, ReportComponent],
  providers: [ReportsService],
})
export class ReportModule {}
